import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

/**
 * GuestCTA — Inline call-to-action shown in place of an interactive control
 * (chat input, "Apply", "Send Offer", "Edit"…) when the user is browsing
 * anonymously. Encourages registration without blocking the read view.
 */
export function GuestCTA({ message, ctaLabel = "Jetzt registrieren", testId, compact = false }) {
  if (compact) {
    return (
      <Link
        to="/login"
        data-testid={testId || "guest-cta-compact"}
        className="inline-flex items-center gap-1.5 text-[11px] text-[#00F0FF] hover:underline font-['Outfit']"
      >
        <Lock className="w-3 h-3" /> {message || "Anmelden zum Interagieren"}
      </Link>
    );
  }
  return (
    <div
      data-testid={testId || "guest-cta-block"}
      className="rounded-lg border border-[#00F0FF]/20 bg-[#00F0FF]/[0.04] px-4 py-4 flex items-start gap-3"
    >
      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00F0FF]/10 flex-shrink-0">
        <Lock className="w-4 h-4 text-[#00F0FF]" />
      </div>
      <div className="flex-1">
        <p className="text-xs text-white leading-relaxed">
          {message || "Du schaust dir Project Radar AR im Vorschau-Modus an. Erstelle ein kostenloses Konto, um zu interagieren."}
        </p>
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 mt-2 text-[11px] text-[#00F0FF] hover:underline font-['Outfit'] font-semibold"
        >
          {ctaLabel} <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}

export default GuestCTA;
